import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
function CsdHeadSection({ onScroll }: { onScroll: () => void }) {
  return (
    <section className="w-full min-h-screen h-full relative flex flex-col">
      <video
        src={require("../../Assets/videos/CSD.webm")}
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 flex flex-col gap-5 items-start p-10 justify-center bg-black/50">
        <motion.h1
          className="text-white text-4xl font-light"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          Custom Software Development
        </motion.h1>
        <motion.p
          className="text-base text-white"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut", delay: 0.3 }}
        >
          Optimize your business processes with custom software solutions,
          ensuring seamless workflow automation, scalability, and efficiency
        </motion.p>
        <motion.button
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          onClick={onScroll}
          className="px-4 py-2 border-2 border-white rounded-full flex items-center gap-2 text-white group ease-in"
        >
          <ArrowRight className="group-hover:rotate-[360deg] duration-200 ease-in" />
          Hire A Custom Software Developer
        </motion.button>
      </div>
    </section>
  );
}

export default CsdHeadSection;
